// extracted by mini-css-extract-plugin
export default {"adContentDisplay":"ad-image_adContentDisplay__8Qre2","imageContainer":"ad-image_imageContainer__kcEnk","image":"ad-image_image__3CUcj","secondImage":"ad-image_secondImage__w4BIs"};